var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSpeed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 40.303,
    viewBox: "0 0 50 40.303",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "speed-grader-svgrepo-com",
    d: "M5.535,241.051a19.505,19.505,0,0,0,3.954,9.536L5.08,254A25.1,25.1,0,0,1,0,241.734Zm43.239-10.236a24.853,24.853,0,0,1,1.04,4.659,26.266,26.266,0,0,1,0,6.254A25.094,25.094,0,0,1,44.733,254l-4.408-3.416a19.505,19.505,0,0,0,3.954-9.536,20.761,20.761,0,0,0,0-4.9,19.489,19.489,0,0,0-.8-3.6Zm-3.532-11.023,3.942,3.943L26.3,246.617l-13.59-13.59,3.942-3.943,9.647,9.647,18.94-18.94ZM5.08,223.206l4.408,3.416a19.506,19.506,0,0,0-3.954,9.536L0,235.474a25.1,25.1,0,0,1,5.08-12.268Zm16.7-9.507.683,5.535a19.458,19.458,0,0,0-9.536,3.954l-3.418-4.408A25.058,25.058,0,0,1,21.778,213.7Zm6.259,0a25.075,25.075,0,0,1,12.268,5.08l-3.418,4.408a19.448,19.448,0,0,0-9.533-3.954Z",
    transform: "translate(0 -213.699)",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSpeed);
export default __webpack_public_path__ + "static/media/icon-speed.2cd3d1f3e5503d4090f64cc520868470.svg";
export { ForwardRef as ReactComponent };